package org.hs_soft.runmynesto.domain.usecase.product.tab_click_collect

import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_click_collect.update_properties.UpdatePropertiesModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_click_collect.UpdateProductPropertiesRepository


class UpdateProductPropertiesUseCase(
    private val repository: UpdateProductPropertiesRepository
) {
    suspend operator fun invoke(
        productId: String,
        minOrder:Double?=null,
        maxOrder:Double?=null,
        timeLeadDays:Double?=null,
        isAlcohol:Boolean?=null,
        isVegan:Boolean?=null,
        isVegetarian:Boolean?=null
    ): UpdatePropertiesModel {
        return repository.updateProductProperties(
            productId=productId,
            minOrder= minOrder,
            maxOrder=maxOrder,
            timeLeadDays=timeLeadDays,
            isAlcohol=isAlcohol,
            isVegan=isVegan,
            isVegetarian=isVegetarian
        )
    }
}